// Fonte única de verdade — menu público do widget de atendimento.
// Para alterar: edite aqui + crie/atualize labels no Chatwoot + ajuste TEAM_MAP no N8N.

export const MENU = [
  {
    id: 'agendamento',
    label: 'Agendamento',
    icon: 'bi-calendar3',
    team: 'agendamento',        // label e team no Chatwoot
  },
  {
    id: 'cobrancas_avarias',
    label: 'Cobranças de Avarias',
    icon: 'bi-receipt-cutoff',
    team: 'cobrancas_imp',
  },
  {
    id: 'importador_bloqueado',
    label: 'Importador Bloqueado',
    icon: 'bi-lock-fill',
    team: 'cobrancas_imp',
  },
  {
    id: 'financeiro',
    label: 'Financeiro',
    icon: 'bi-cash-coin',
    team: 'financeiro',
  },
  {
    id: 'vagas',
    label: 'Vagas',
    icon: 'bi-briefcase',
    info: {
      message: 'Para informações sobre vagas acesse',
      url: 'https://transtecworld.com/vagas',
      urlLabel: 'transtecworld.com/vagas',
    },
  },

];

// Mapa label → team Chatwoot — usado como referência para configurar o N8N.
// Preencher com os IDs reais após criar as equipes em Configurações → Equipes.
export const LABEL_TEAM_MAP = {
  agendamento:          3, // ID da equipe Agendamento
  cobrancas_avarias:    8, // ID da equipe cobrancas_imp
  importador_bloqueado: 2, // ID da equipe cobrancas_imp (mesmo time)
  financeiro:           9,    // ID da equipe Financeiro
};
